export class RequestCanceledError extends Error {
  constructor (message) {
    super(message);
    this.name = 'RequestCanceledError';
  }
}
